import { useEffect, useRef } from 'react'
import { Card, Spin, Typography } from 'antd'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import keycloakAuth from '../services/keycloakAuth'
import './RedirectScreen.css'

const { Text, Title } = Typography

const Login = () => {
  const { token } = useSelector((state) => state.auth)
  const navigate = useNavigate()
  const loginTriggered = useRef(false)

  useEffect(() => {
    if (token) {
      navigate('/dashboard', { replace: true })
      return
    }

    if (!loginTriggered.current) {
      loginTriggered.current = true
      // Always force fresh login to avoid re-authentication mode
      keycloakAuth.login(true)
    }
  }, [token, navigate])

  return (
    <div className="redirect-screen">
      <Card className="redirect-card" bodyStyle={{ padding: 40 }} bordered={false}>
        <div className="redirect-card__icon">
          <img src="/logo.png" alt="Quantum Husky" />
        </div>
        <Title level={3} className="redirect-card__title">
          Preparing secure login
        </Title>
        <Text type="secondary" className="redirect-card__hint">
          Redirecting you to Keycloak...
        </Text>
        <div className="redirect-card__spinner">
          <Spin size="small" />
        </div>
        <div className="redirect-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </Card>
    </div>
  )
}

export default Login
